<template>
  <div id="edit_news_detail">
    <div class="page-header section-image" data-parallax="true" style="background-image: url('/static/img/bg3.jpg'); height:50vh" >
      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto">
            <div class="brand text-center">
              <h2 class="title">(編輯){{ title }}</h2>
              <!-- <h2 class="title">{{ time }}</h2> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main main-raised">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link to="/news"><b>最新消息</b></router-link>
        </li>
        <li class="breadcrumb-item"><b>{{ time }}</b></li>
        <li class="breadcrumb-item" aria-current="page"><b>(編輯) {{ title }}</b></li>
      </ol>
      <div class="container">
        <div class="progress" style="height: 10px;" v-if="prossVal !=0">
          <div class="progress-bar" role="progressbar" :style="{width: prossVal + '%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{prossVal}}%</div>
        </div>
        <!-- <div class="section">-->
          <label class="btn btn-info">
            <input type="file" class="custom-file-input" style="display: none;" id="img-upload" multiple accept="image/*" @change="uploadImg($event)" />
            <i class="fa fa-photo"></i> 上傳圖片
          </label>
          <button class="btn btn-social btn-fill btn-behance" @click="save_data">
              <span class="material-icons mr-2">save_alt</span> 儲存
          </button>
          <button class="btn btn-social btn-fill btn-tumblr" @click="cancel_edit">
              <span class="material-icons mr-2">keyboard_return</span> 取消編輯
          </button>
          <div class="row">
            <template v-for="(item, index) in imgString">
              <div class="col-md-3" :key="index">
                <div class="card">
                  <img class="card-img-bottom" :src="item.src" alt="Card image cap">
                  <div class="text-center">
                    <button class="btn btn-social btn-fill btn-facebook" @click="imgString.splice(index,1)">
                      <span class="material-icons mr-2">delete_forever</span> 刪除
                    </button>
                  </div>   
                </div>
              </div>
            </template>
            <template v-for="(item, index) in imgData">
              <div class="col-md-3" :key="index">
                <div class="card">
                  <img class="card-img-bottom" :src="item.img" alt="Card image cap">
                  <div class="text-center">
                    <button class="btn btn-social btn-fill btn-facebook" @click="del(item.id)">
                      <span class="material-icons mr-2">delete_forever</span> 刪除
                    </button>
                  </div>   
                </div>
              </div>
            </template>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import EXIF from "exif-js";

export default {
  name: "edit_news_detail",
  props: ["id","time","title","parag"],
  data() {
    return {
      description:'',
      imgNumLimit: 100,
      imgFile: [],
      imgString: [],  // 圖片主要顯示(新加入)
      imgData: [],    // 圖片主要顯示(資料庫出來)
      prossVal: 0     // 進度條顯示
    };
  },
  methods: {
    getData: function(){
      var vm = this;
      var data = []; 
      var newItem = []
      
      axios
        .post(`/api/getnewsImg`,{
          pid: vm.id
        })
        .then(res => {
          vm.imgData = res.data.data;  
        })
        .catch(err => {
          console.log(err);
        });   
    },
    uploadImg: function(e) {      
      let tag = e.target;
      let fileList = tag.files;
      let imgNum = fileList.length;
      let _this = this;
      _this.prossVal = 0;     // 進度條歸零
      _this.imgString = [];   // 圖片資料清零
      _this.imgFile = [];     // 圖片資料清零
      if (imgNum > this.imgNumLimit) {
        alert("一次最多上傳" + this.imgNumLimit + "張圖片！");
        return;
      }
      var Orientation;
      for (let i = 0; i < imgNum; i++) {
        _this.imgFile.push(fileList[i]);
        EXIF.getData(fileList[i], function() {
          Orientation = EXIF.getTag(fileList[i], "Orientation");
        });
        // file to base64
        let reader = new FileReader();
        reader.readAsDataURL(fileList[i]);        
        reader.onload = function() {
          var oReader = new FileReader();
          oReader.onload = function(e) {
            var image = new Image();
            image.src = e.target.result;
            image.onload = function() {
              
              var expectWidth = this.naturalWidth;
              var expectHeight = this.naturalHeight;
              // if (
              //   this.naturalWidth > this.naturalHeight &&
              //   this.naturalWidth > 800
              // ) {
              //   expectWidth = 800;
              //   expectHeight =
              //     (expectWidth * this.naturalHeight) / this.naturalWidth;
              // } else if (
              //   this.naturalHeight > this.naturalWidth &&
              //   this.naturalHeight > 1200
              // ) {
              //   expectHeight = 1200;
              //   expectWidth =
              //     (expectHeight * this.naturalWidth) / this.naturalHeight;
              // }
              var canvas = document.createElement("canvas");
              var ctx = canvas.getContext("2d");
              canvas.width = expectWidth;
              canvas.height = expectHeight;
              ctx.drawImage(this, 0, 0, expectWidth, expectHeight);

              // var expectWidth = this.naturalWidth;
              // var expectHeight = this.naturalHeight;
              // var scale = expectWidth / expectHeight;
              // var width_x = 300;
              // var height_x = parseInt(width_x / scale);
              // var canvas = document.createElement("canvas");
              // var ctx = canvas.getContext("2d");
              // canvas.width = width_x;
              // canvas.height = height_x;
              // ctx.drawImage(this, 0, 0, expectWidth, expectHeight, 0, 0, width_x, height_x);

              var base64 = null;

              base64 = canvas.toDataURL("image/jpeg", 1);
              _this.imgString.push({ src: base64 });
              
              // 計算照片上傳進度
              _this.prossVal = Math.floor((_this.imgString.length / imgNum)*100);

              // if (fileList[i].size / 1024000 > 1) {
              //   console.log('行643: 壓縮')
              //   _this.imgScale(base64, 4);
              // } 
              // else {
              //   console.log('行647: 未壓縮')
              //   _this.imgString.push({ src: base64 });
              // }
             
              
              // console.log(JSON.stringify(_this.imgString));
            };
          };
        
          oReader.readAsDataURL(fileList[i]);
        };
      }
    },
    async save_data(){
      var vm = this;
      var data = [];
      if(vm.imgString.length != 0){
        // 先加入新照片
        for(var i = 0; i < vm.imgString.length; i++){          
          await vm.dataImg({
            id: null,
            pid: vm.id,
            img: vm.imgString[i].src
          })
          // 進度條
          // vm.prossVal = Math.floor(( i / save_data.length )*100);
        }
        // vm.imgString.forEach(function(item, idx){
        //   data.push({
        //     id: null,
        //     pid: vm.id,
        //     img: item.src
        //   });
        // });
        vm.$router.push({name:'news_detail',params:{ id: vm.id, title: vm.title, time: vm.time, parag: vm.parag }});
        // axios
        //   .post(`/api/savenewsDetailImg`, data)
        //   .then(res => {
        //     if(res.status == 200){
        //       // alert('success')
        //       vm.$router.push({name:'news_detail',params:{ id: vm.id, title: vm.title, time: vm.time, parag: vm.parag }});

        //     }
        //   })
        //   .catch(err => {
        //     console.log(err);
        //   });
      }
      else{
        alert('請選擇照片');
      }
      
    },
    // 儲存照片
    async dataImg(dataImg){
        var vm = this;
                
        return new Promise(resolve => {
            axios
              .post(`/api/savenewsDetailImg`,dataImg)
              .then(res => {                  
                  resolve();  // 表示完成
              })
              .catch(err => {
                  console.log(err);
              });
        });
    },
    del: function(id){
      var vm = this;
      axios
        .post(`/api/delnewsDetailImg`, {
          id: id
        })
        .then(res => {
          if(res.status == 200){
            alert('刪除成功');
            vm.getData();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    cancel_edit: function(){
      var vm = this;
      
      vm.$router.push({name:'news_detail',params:{ id: vm.id, title: vm.title, time: vm.time, parag: vm.parag }});

    }
  },
  filters: {},
  computed: {},
  created() {
    this.getData();
  },
  mounted() {},
  components: {},
  watch: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/about/edit_news_detail.vue